import { AxiosRequestConfig } from "axios"

import { privateFetch } from "../libs/axios"
import {
  CreatePromoCodeRequestType,
  GetAllOffersResponseType,
  PromoCodeType,
} from "../types/PromoCodeServiceTypes"
import { jsonToQueryString } from "../utils/Common"

export const addPromoCode = async (body: CreatePromoCodeRequestType) =>
  await privateFetch().post<PromoCodeType>("/api/v1/offers", body)

export const updatePromoCode = async (id: string, body: CreatePromoCodeRequestType) =>
  await privateFetch().put<PromoCodeType>(`/api/v1/offers/${id}`, body)

export const deletePromoCode = async (id: string) =>
  await privateFetch().delete(`/api/v1/offers/${id}`)

export const getPromoCodeById = async (id: string, config: AxiosRequestConfig = {}) =>
  await privateFetch().get<PromoCodeType>(`/api/v1/offers/${id}`, config)

export const getAllPromoCode = async (filter = {}) =>
  await privateFetch().get<GetAllOffersResponseType>(`/api/v1/offers/${jsonToQueryString(filter)}`)
